<div class="filter-label mt-2 ">
    <label title="{{props['fieldDescription']}}" class="field-label {{ getStatus() }} {{ getFilterFontStatus() }}" *ngIf="props.label" [attr.id]="id + '-label'" (click)="conmuteHide()">
    {{ props.label }}
  </label>
</div>
 
  <div *ngIf="!this.hide" class="filter-container">
    <div *ngIf="false" class="filter-description">
        <span class="field-description">{{ props.fieldDescription }}</span>
    </div>
    <div class="filter-content bulk-radio-wrapper">
      <div *ngFor="let opt of this.datasource | async as options; let i = index" [attr.for]="id + '-' + i">
              <input
              type="radio"
              [id]="id + '-' + i"
              [name]="id"
              [checked]="formControl?.value === getValue(opt)"
              (change)="select(opt.code)"
              [disabled]="props.disabled || opt.disabled || false"
              />
              <label [for]="id + '-' + i" class="option-label">{{ getLabel(opt) }}</label>
          </div>
      <div *ngIf="showClear()" style="margin-left:auto">
                  <button type="button" class="btn btn-light" 
                      title="Clear selected Options" (click)="clear()">Clear</button>
      </div>
    </div>
  </div>

